<template>
  <div class='cloud-services-asset-details-row' :class='{"is-last": isLast}'>
    <div class='cloud-services-asset-details-row__content'>
      <div class="main-info" @click="openRow">
        <div class="main-info__type-data"> {{ getType }} </div>
        <div class="main-info__critical"> <ComplianceSeverity class='main-info__critical__data' :value='getCritical'/> </div>
        <div class="main-info__high"> <ComplianceSeverity class='main-info__high__data' :value='getHigh'/> </div>
        <div class="main-info__medium"> <ComplianceSeverity class='main-info__medium__data' :value='getMedium'/> </div>
        <div class="main-info__low"> <ComplianceSeverity class='main-info__low__data' :value='getLow'/> </div>
        <div class='right-section'>
          <div class='arrow-expand-section'>
            <v-icon class="expand-icon" :class="{ expand: isOpen }">expand_more</v-icon>
          </div>
        </div>
      </div>
      <div class="cloud-services-asset-details" v-if="isOpen">
        <wombat-table
          :items="servicesDescriptionItemsPaginated"
          :columns="tableColumnsServicesDescription"
          :name='servicesDescriptionName'
          :resize="false"
          :loadingItems="true"
          :columnsReorder="false"
          :itemHeight="58"
          :noResultsMessage="$t('noResultsFound')"
          class='details-table'
        >
          <component
            slot="row-cell"
            slot-scope="rowCell"
            class="row-cell"
            @showComplianceDetails="showComplianceDetailsHandler"
            :is="tableRowCellComponentsHashServicesDescription[rowCell.column.name] || tableRowCellComponentsHashServicesDescription.default"
            :item="rowCell.item"
            :column="rowCell.column"
          />
        </wombat-table>
        <div class='cloud-services-asset-details__buttons' v-if='servicesDescriptionItems.length > 3'>
          <span class='cloud-services-asset-details__buttons__show-all' @click='changeIsShowAll'> {{showAllToggleCaption}} </span>
          <span class="cloud-services-asset-details__buttons__show-more" @click='changeShowMore'> {{showMoreToggleCaption}} </span>
        </div>
      </div>
    </div>
    <cloud-compliance-details-popup
      @closed="onCloseComplianceDetailsPopup"
      :visible-popup="showComplianceDetailsPopup"
    >
    </cloud-compliance-details-popup>
  </div>
</template>

<script>
import WombatTable from '@/components/WombatTable/WombatTable.vue';
import WombatRowDefaultCell from '@/components/WombatTable/WombatRowDefaultCell.vue';
import { servicesDescriptionTabTableColumns } from '@/services/tableColumns';
import StatusTableCell from '@/components/tableCells/cloudServicesTableCells/StatusTableCell.vue';
import DescriptionTableCell from '@/components/tableCells/cloudServicesTableCells/DescriptionTableCell.vue';
import SeverityTableCell from '@/components/tableCells/cloudServicesTableCells/SeverityTableCell.vue';
import AssetsTableCell from '@/components/tableCells/cloudServicesTableCells/AssetsTableCell.vue';
import ComplianceSeverity from '@/components/common/ComplianceSeverity.vue';
import { CLEAR_CLOUD_SERVICES_LEVEL_ITEMS, LOAD_CLOUD_SERVICES_LEVEL_ITEMS } from '@/store/project/actionTypes';
import { FORTH_LEVEL, THIRD_LEVEL } from '@/constants/configuration';
import { mapGetters } from 'vuex';
import CloudComplianceDetailsPopup from '@/components/popup/CloudComplianceDetailsPopup.vue';

export default {
  name: 'CloudServicesAssetDetailsRow',
  props: {
    item: {
      type: Object,
      required: true,
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    WombatTable,
    WombatRowDefaultCell,
    ComplianceSeverity,
    CloudComplianceDetailsPopup,
  },
  data() {
    return {
      showAllCompliance: false,
      isOpen: false,
      showComplianceDetailsPopup: false,
      isShowAll: false,
      showMore: 1,
    };
  },
  methods: {
    async openRow() {
      if (!this.isOpen) {
        await this.$store.dispatch(LOAD_CLOUD_SERVICES_LEVEL_ITEMS, {
          domain: this.getTld, serviceName: this.getServiceName, region: this.getRegion, checkType: this.getType, layer: THIRD_LEVEL,
        });
      } else {
        await this.$store.dispatch(CLEAR_CLOUD_SERVICES_LEVEL_ITEMS, {
          domain: this.getTld, serviceName: this.getServiceName, region: this.getRegion, checkType: this.getType, layer: THIRD_LEVEL,
        });
      }
      this.isOpen = !this.isOpen;
    },
    onCloseComplianceDetailsPopup() {
      this.showComplianceDetailsPopup = false;
    },
    async showComplianceDetailsHandler(payload) {
      await this.$store.dispatch(LOAD_CLOUD_SERVICES_LEVEL_ITEMS, {
        domain: this.getTld,
        serviceName: this.getServiceName,
        region: this.getRegion,
        checkType: this.getType,
        description: payload.description,
        status: payload.status,
        layer: FORTH_LEVEL,
      });
      this.showComplianceDetailsPopup = true;
    },
    changeIsShowAll() {
      this.isShowAll = !this.isShowAll;
      if (!this.isShowAll) {
        this.showMore = 1;
      } else {
        this.showMore = Math.ceil(this.servicesDescriptionItems.length / 3);
      }
    },
    changeShowMore() {
      if (!(this.showMore * 3 >= this.servicesDescriptionItems.length)) {
        this.showMore += 1;
        this.isShowAll = false;
        if (this.showMore * 3 >= this.servicesDescriptionItems.length) {
          this.isShowAll = true;
        }
      } else if (this.showMore * 3 >= this.servicesDescriptionItems.length) {
        this.isShowAll = false;
        this.showMore -= 1;
      }
    },
  },
  computed: {
    ...mapGetters([
      'cloudServicesThirdLevelItems',
      'cloudServicesFourthLevelItems',
    ]),
    showAllToggleCaption() {
      return this.isShowAll || this.showMore * 3 >= this.servicesDescriptionItems.length ? this.$t('services.tab.details.hide') : this.$t('services.tab.details.show.all');
    },
    showMoreToggleCaption() {
      return this.isShowAll || this.showMore * 3 >= this.servicesDescriptionItems.length ? this.$t('services.tab.details.show.less') : this.$t('services.tab.details.show.more');
    },
    tableColumnsServicesDescription() {
      const columns = [
        servicesDescriptionTabTableColumns.description,
        servicesDescriptionTabTableColumns.severity,
        servicesDescriptionTabTableColumns.assets,
        servicesDescriptionTabTableColumns.status,
      ].filter(column => column)
        .map(column => ({
          ...column,
          title: column.title && this.$t(column.title),
        }));
      return [...columns];
    },
    tableRowCellComponentsHashServicesDescription() {
      return {
        description: DescriptionTableCell,
        severity: SeverityTableCell,
        assets: AssetsTableCell,
        status: StatusTableCell,
        default: WombatRowDefaultCell,
      };
    },
    servicesDescriptionName() {
      return `services-description-table-${this.getServiceName.replace(/[^a-zA-Z0-9-]/g, '')}-${this.getRegion.replace(/[^a-zA-Z0-9-]/g, '')}-${this.getType.replace(/[^a-zA-Z0-9-]/g, '')}`;
    },
    servicesDescriptionItems() {
      const formattedItems = [];
      this.cloudServicesThirdLevelItems.forEach(service => {
        if (service.serviceName === this.getServiceName && service.region === this.getRegion && service.tld === this.getTld && service.checkType === this.getType) {
          formattedItems.push(service);
        }
      });
      const sortingOrder = {
        FAIL: 3,
        PASS: 2,
        INFO: 1,
      };
      formattedItems.sort((a, b) => {
        const statusA = sortingOrder[a.status] || 0;
        const statusB = sortingOrder[b.status] || 0;

        if (statusA === statusB) {
          const severityOrder = {
            critical: 1,
            high: 2,
            medium: 3,
            low: 4,
          };
          const severityA = severityOrder[a.severity] || 0;
          const severityB = severityOrder[b.severity] || 0;
          return severityA - severityB;
        }
        return statusB - statusA;
      });
      return formattedItems.map((item, index) => ({
        ...item,
        id: index + 1,
      }));
    },
    servicesDescriptionItemsPaginated() {
      let formattedItems = this.servicesDescriptionItems;
      if (!this.isShowAll) {
        if (!(3 * this.showMore > formattedItems.length)) {
          formattedItems = formattedItems.slice(0, 3 * this.showMore);
        }
      }
      return formattedItems;
    },
    getType() {
      return this.item.checkType;
    },
    getServiceName() {
      return this.item.serviceName;
    },
    getRegion() {
      return this.item.region;
    },
    getTld() {
      return this.item.tld;
    },
    getCritical() {
      return {
        count: this.item.critical,
        severity: this.$t('critical'),
      };
    },
    getHigh() {
      return {
        count: this.item.high,
        severity: this.$t('high'),
      };
    },
    getMedium() {
      return {
        count: this.item.medium,
        severity: this.$t('medium'),
      };
    },
    getLow() {
      return {
        count: this.item.low,
        severity: this.$t('low'),
      };
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.cloud-services-asset-details-row {
  min-height: rem(58);
  border-bottom: 1px solid var(--border-primary);
  display: flex;
  padding: $space-1 0;
  align-items: center;

  &.is-last {
    border-bottom: none;
  }

  &__content {
    width: 100%;

    .cloud-services-asset-details {
      padding-right: 8%;
      padding-left: 7.1%;
      width: 100%;

      .details-table {
        margin-top: $space-4;
        min-height: rem(40);
      }

      &__buttons {
        display: flex;
        justify-content: right;
        padding-right: 5.8%;

        &__show-all,
        &__show-more {
          color: $action-button-text-color;
          font-family: $default-application-font-regular;
          font-size: $font-size-base;
          letter-spacing: 0;
          padding: 0 $space-8;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    .main-info {
      align-items: center;
      display: flex;
      color: var(--text-primary);
      cursor: pointer;
      font-family: $default-application-font-medium;
      font-size: $font-size-base;
      line-height: $space-5;
      height: fit-content;
      margin-right: 3.5%;
      flex-direction: row;
      margin-left: 4%;

      &__type-data {
        width: 53%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &__critical {
        width: 9.5%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &__data {
          height: rem(25);
          width: rem(50);
        }
      }

      &__high {
        width: 9.5%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &__data {
          height: rem(25);
          width: rem(50);
        }
      }

      &__medium {
        width: 9.5%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &__data {
          height: rem(25);
          width: rem(50);
        }
      }

      &__low {
        width: 9.5%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &__data {
          height: rem(25);
          width: rem(50);
        }
      }

      .right-section {
        .arrow-expand-section {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
}
</style>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.cloud-services-asset-details-row {
  .main-info {
    &__critical {
      position: absolute;
      left: 54%;
      width: rem(150);
    }

    &__high {
      position: absolute;
      left: 63%;
      width: rem(150);
    }

    &__medium {
      position: absolute;
      left: 72%;
      width: rem(150);
    }

    &__low {
      position: absolute;
      left: 80.28%;
      width: rem(150);
    }

    .right-section {
      position: absolute;
      right: 10%;
    }
  }

  .wombat-table {
    .cell.column-severity {
      margin-right: -4%;

      .wombat-header-default-cell {
        margin-left: $space-0-5;
      }
    }

    .cell.column-status {
      margin-right: 0.5%;

      .wombat-header-default-cell {
        margin-left: $space-2;
      }
    }

    .cell.column-assets {
      margin-right: -4.7%;

      .wombat-header-default-cell {
        margin-left: $space-2;
      }
    }

    .cell.column-description {
      flex-basis: 48.5%;
      flex-shrink: 0;
      padding-right: 10.5%;
    }
  }
}
</style>
